<template>
  <b-tabs v-model="activeTab" :animated="false">
    <b-tab-item value="events" icon="calendar" :label="$t('events')">
      <EventsTable :events-collection="eventsCollection" :archive-collection="archiveCollection" />
    </b-tab-item>

    <b-tab-item value="bills" icon="file-document-outline" :label="$t('bills')">
      <BillsTable :bills-collection="billsCollection" />
    </b-tab-item>
    <b-tab-item value="paymentMethods" icon="credit-card-outline" :label="$t('paymentMethods')">
      <MandatesTable :mandates="mandates" />
    </b-tab-item>
    <b-tab-item value="admins" icon="account-outline" :label="$t('admins')">
      <AdminTable :admin-collection="adminCollection" />
    </b-tab-item>
    <b-tab-item v-if="enablePartner" value="partner" icon="certificate-outline" :label="$t('affiliateTools')">
      <PartnerTab :key="locale" :organization-id="$store.getters.getOrganizationId" />
    </b-tab-item>
    <!-- <b-tab-item
      value="conditions"
      icon="account-cash-outline"
      :label="$t('conditions')"
    >
      <ConditionTable />
    </b-tab-item> -->
    <b-tab-item value="surveys" icon="head-question-outline" :label="$t('surveys')">
      <SurveysTable :surveys-collection="surveysCollection" />
    </b-tab-item>
    <b-tab-item value="settings" icon="cog-outline" :label="$t('settings')">
      <OrganizationSettings :organization-id="organizationId" />
    </b-tab-item>
  </b-tabs>
</template>

<script>
import EventsTable from "@/components/EventsTable.vue";
import BillsTable from "@/components/BillsTable.vue";
import MandatesTable from "@/components/MandatesTable.vue";
import OrganizationSettings from "@/components/OrganizationSettings";
// import ConditionTable from "@/components/ConditionTable";
import AdminTable from "@/components/AdminTable";
import PartnerTab from "@/components/PartnerTab";
import SurveysTable from "@/components/survey/SurveysTable";
import { db } from "@/firebase";

export default {
  name: "DashboardTabs",
  components: {
    EventsTable,
    BillsTable,
    MandatesTable,
    OrganizationSettings,
    AdminTable,
    // ConditionTable,
    PartnerTab,
    SurveysTable,
  },
  data() {
    return {
      activeTab: this.$route.query.tab || localStorage.activeTab,
      events: [],
      bills: [],
      mandates: [],
      admins: [],
      organizations: [],
      errors: [],
      settings: [],
      enablePartner: false,
    };
  },
  computed: {
    organizationId() {
      return this.$route.params.organizationId;
    },
    eventsCollection() {
      return db.doc(`organizations/${this.organizationId}`).collection("events");
    },
    archiveCollection() {
      return db.doc(`organizations/${this.organizationId}`).collection("archivedEvents");
    },
    billsCollection() {
      return db.doc(`organizations/${this.organizationId}`).collection("bills");
    },
    mandatesCollection() {
      return db.doc(`organizations/${this.organizationId}`).collection("mandates");
    },
    adminCollection() {
      return db.doc(`organizations/${this.organizationId}`).collection("admins");
    },
    errorCollection() {
      return db.collection("errors");
    },
    settingsCollection() {
      return db.doc(`organizations/${this.organizationId}`);
    },
    organizationsCollection() {
      return db.collection("organizations");
    },
    surveysCollection() {
      return db.collection("surveys").where("organizationId", "==", this.organizationId);
    },
    newAudioURL() {
      return URL.createObjectURL(this.newAudio);
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    activeTab() {
      localStorage.activeTab = this.activeTab;
    },
    settings() {
      if (this.settings.isAgency || this.settings.isBroker) {
        this.enablePartner = true;
      }
    },
    enablePartner() {
      if (localStorage.activeTab == "partner") {
        this.activeTab = "";
        setTimeout(() => {
          this.activeTab = "partner";
        }, 500);
      }
    },
  },
  async created() {
    let userSnap = await db.collection("member_translators").doc(this.$store.getters.getCurrentUser.uid).get();
    if (userSnap.exists) {
      this.enablePartner = true;
    }
  },
  firestore() {
    return {
      settings: this.settingsCollection,
      mandates: this.mandatesCollection,
    };
  },
};
</script>
